<script>    
    import {
    Container,
    Row,
    Col,
    Button,
    Card,
    CardBody,
    CardTitle,
    Modal,
    Input,
  } from "sveltestrap";
  
  </script>
  
  <div class="page-content">
    <Container fluid>
      <Row>
        <Col lg="12">
          <Card><CardBody>
          <div class="mb-4 h1 card-title"><h1>KLAID 2022 Challenge 모델 제출 가이드 문서</h1></div>
            <p class="card-text">
                이 문서는 KLAID(Korean Legal AI Datasets)에 모델 및 결과를 제출하는 과정을 담은 문서입니다.<br/>
                모델을 제출해주시면 Test set에 대한 Accuracy, Macro F1 score가 Leaderboard에 기록됩니다.
            </p>
        </CardBody></Card>
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          <Card><CardBody>
          <div class="mb-4 h1 card-title"><h2>주의사항</h2></div>
            <p class="card-text">
              ※ CodaLab은 모델 학습을 위한 서비스가 아닙니다. 학습이 완료된 모델의 예측 및 평가에만 사용하시기 바랍니다.
            </p>
        </CardBody></Card>
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          <Card><CardBody>
          <div class="mb-4 h1 card-title"><h2>들어가며</h2></div>
            <p class="card-text">
              KLAID는 <a href="https://worksheets.codalab.org/" target="_blank">CodaLab</a>에서 제공하는 Worksheets를 이용해서 모델 및 결과를 평가하고 기록합니다. 이 문서에서는 모델을 KLAID에 제출하기 위한 방법만을 기술하고 있습니다. CodaLab의 Worksheets에 대해 더 자세히 알고 싶으시면 CodaLab에서 제공하는 <a href="https://codalab-worksheets.readthedocs.io/en/latest/" target="_blank">가이드</a>를 참고해주시기 바랍니다.
            </p>
        </CardBody></Card>
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          <Card><CardBody>
          <div class="mb-4 h1 card-title"><h2>환경 구성</h2></div>
            <p class="card-text">
              CodaLab Worksheets에서는 동작 환경을 도커로 구성할 수 있습니다. 그러나 이 문서에서 도커까지 다루지는 않습니다. 도커에 대한 도움이 필요하시다면 도커에서 제공하는 <a href="https://docs.docker.com/" target="_blank">공식 가이드 문서</a>를 참고해주시기 바랍니다.
            </p>

            <div class="mb-4 h1 card-title"><h3>예제</h3></div>
            <p class="card-text">
              이 예제는 CodaLab Worksheets에서 도커 허브에 업로드된 이미지를 사용하는 방법을 설명하기 위해 간소화된 예제로, KLAID의 테스크와는 관련이 없습니다.
            </p>
            
              <ol>
                <li>
                  <p class="card-text">
                  CodaLab에 로그인하여 Worksheets에 접속하면 다음과 같은 화면이 표시됩니다.
                  </p>
                  <img src="assets/images/leaderboard-submission/Untitled.png" alt="1"
                  class="img-thumbnail mx-auto d-block">
                </li>
                <li>
                 <p class="card-text">
                  우측 상단의 ADD를 클릭하여 새로운 Worksheets를 생성합니다.
                 </p>
                 <img src="assets/images/leaderboard-submission/Untitled 1.png" alt="1"
                  class="img-thumbnail mx-auto d-block">
                </li>
                <li>
                  <p class="card-text">
                    생성된 Worksheets로 접속합니다.
                  </p>
                  <img src="assets/images/leaderboard-submission/Untitled 2.png" alt="1"
                   class="img-thumbnail mx-auto d-block">
                 </li>
                 <li>
                  <p class="card-text">
                    Worksheets에서 컨테이너를 실행합니다.
                  </p>
                  <img src="assets/images/leaderboard-submission/Untitled 3.png" alt="1"
                   class="img-thumbnail mx-auto d-block">
                 </li>
                 <li>
                  <p class="card-text">
                    실행된 컨테이너를 클릭하여 상세정보를 확인할 수 있습니다.
                  </p>
                  <img src="assets/images/leaderboard-submission/Untitled 4.png" alt="1"
                   class="img-thumbnail mx-auto d-block">
                 </li>
              </ol>
              <p class="card-text">
              이 예제에서는 bitnami/pytorch 도커에 설치된 모듈들을 확인할 수 있습니다.
            </p>
              <img src="assets/images/leaderboard-submission/Untitled 5.png" alt="1"
                   class="img-thumbnail mx-auto d-block">
            
        </CardBody></Card>
        </Col>
      </Row>

      <Row>
        <Col lg="12">
          <Card><CardBody>
          <div class="mb-4 h1 card-title"><h2>모델 실행</h2></div>

          <ol>
            <li>
              <p class="card-text">
                소스 코드 및 학습 모델(train model) 업로드 합니다. 
              </p>
              <pre><code>※ 학습이 완료된 모델을 업로드하셔야 합니다.
※※ 모델 추론이 아닌 학습에만 필요한 코드들은 업로드하지 않으셔도 됩니다.
※※※ 업로드하기 위한 리소스가 부족할경우 <a href="https://codalab-worksheets.readthedocs.io/en/latest/FAQ/" target="_blank">codalab의 FAQ</a>에 있는 <a href="https://docs.google.com/forms/d/e/1FAIpQLSebCBrglB7z2R7OeHJ_NsVWcUcHVMAW4AQnFxNt0YvTS-rDNA/viewform" target="_blank">CodaLab Worksheets: Disk/Time quota Request Form</a>으로 요청 시 추가 리소스를 할당해줍니다.</code></pre>
              <img src="assets/images/leaderboard-submission/Untitled 6.png" alt="1"
              class="img-thumbnail mx-auto d-block">
            </li>
            <li>
              <p class="card-text">
                Dev data set를 다운로드 합니다. 
              </p>
              <pre>
                <code>
※ 가이드에서 제공하는 add bundle명령어로 추가하시길 권장합니다.
※※ Dev Data Set은 Training Data Set에서 임의로 추출한 2000개의 데이터입니다. 해당 세트는 모델의 추론이 정상적으로 작동되는지 확인하기 위한 세트로, 리더보드의 점수와 직접적인 연관은 없습니다.
                </code>
              </pre>
              <img src="assets/images/leaderboard-submission/Untitled 7-1.png" alt="1"
              class="img-thumbnail mx-auto d-block">
              <pre style="background: rgba(135, 131, 120, 0.15); padding: 1.5em 1em; margin-top: 1em; magin-bottom: 1em;"><code>cl add bundle 0x3adf2f83a890442e8ebdc479164e82d4</code></pre>
            </li>
            <li>
              <p class="card-text">
                소스 코드 및 학습 모델로 Dev data set의 결과를 예측합니다.
              </p>
              <pre>
                <code>
※ 튜토리얼에서 제공하는 KLUE-RoBERTa-base 모델의 경우 requests-memory를 24g로 설정해야하고, Dev Data Set을 추론하는데 걸리는 소요시간은 약 1시간 소요됩니다.</code>
              </pre>
              <ul>
                <li>
                  <p class="card-text">UI를 사용하여 실행하기</p>
                  <img src="assets/images/leaderboard-submission/Untitled 8-1.png" alt="1"
              class="img-thumbnail mx-auto d-block">
                </li>
                <li>
                  <p class="card-text">콘솔창을 사용하여 실행하기</p>
                  <pre style="background: rgba(135, 131, 120, 0.15); padding: 1.5em 1em; margin-top: 1em; magin-bottom: 1em;"><code>cl run :dev_data.json :LJP :ljp_model_and_tokenizer "python3 LJP/LJP/bert_main.py --model_path=ljp_model_and_tokenizer/ljp_model_and_tokenizer --data_file=dev_data.json --tokenizer_path=ljp_model_and_tokenizer/ljp_model_and_tokenizer" -n dev_pred_console --request-docker-image huggingface/transformers-pytorch-cpu:4.18.0 --request-memory 24g</code></pre>
                    <p class="card-txt">:bundle_name ⇒ 참조 번들 추가<br/>
“Command” ⇒ 실행할 커맨드 입력<br/>
-n ⇒ 결과 번들 이름 설정<br/>
request-docker-image ⇒ 사용할 도커 지정<br/>
request-memory ⇒ 필요한 memory</p>
                </li>
              </ul>
              <li>
                <p class="card-text">
                  소스 코드 및 학습 모델의 생성 및 결과 확인
                </p>
                <img src="assets/images/leaderboard-submission/Untitled 9-1.png" alt="1"
                class="img-thumbnail mx-auto d-block">
                <img src="assets/images/leaderboard-submission/Untitled 10-1.png" alt="1"
                class="img-thumbnail mx-auto d-block">
              </li>
              <li>
                <p class="card-text">
                  Evaluation Script를 이용하여 점수를 확인합니다. (※ 가이드에서 제공하는 add bundle명령어로 추가하시길 권장합니다.)
                </p>
                <ol>
                  <li>
                    <p class="card-text">evaluation script 번들 추가</p>
                    <pre style="background: rgba(135, 131, 120, 0.15); padding: 1.5em 1em; margin-top: 1em; magin-bottom: 1em;"><code>cl add bundle 0x5069d99647b0481b9f301f7d72d28480</code></pre>
                  </li>
                  <li>
                    <p class="card-text">Dev data set - label 번들 추가
                    </p>
                    <pre style="background: rgba(135, 131, 120, 0.15); padding: 1.5em 1em; margin-top: 1em; magin-bottom: 1em;"><code>cl add bundle 0x86d2c0a5e6a740858d19358bd75aa5c3</code></pre>
                  </li>
                  <li>
                    <p class="card-text">Evaluation Script 실행하기</p>
                    <ul>
                      <li>
                        <p class="card-text">UI를 사용하여 실행하기
                        </p>
                        <img src="assets/images/leaderboard-submission/Untitled 11-1.png" alt="1"
                class="img-thumbnail mx-auto d-block">
                      </li>
                      <li>
                        <p class="card-text">콘솔창을 사용하여 실행하기
                        </p>
                        <pre style="background: rgba(135, 131, 120, 0.15); padding: 1.5em 1em; margin-top: 1em; magin-bottom: 1em;"><code>cl run :dev_label.json :dev_pred_ui :evaluate.py "python evaluate.py --prediction_file dev_pred_ui/pred_res.json --answer_file dev_label.json" -n dev_score_console</code></pre>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p class="card-text">
                      점수 확인하기
                    </p>
                    <img src="assets/images/leaderboard-submission/Untitled 12-1.png" alt="1"
                    class="img-thumbnail mx-auto d-block">
                  </li>
                </ol>
              </li>
          </ol>
          </CardBody></Card>
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          <Card><CardBody>
          <div class="mb-4 h1 card-title"><h2>모델 제출</h2></div>
            <p class="card-text">
              수고하셨습니다! 위에서 평가 결과로 나온 점수는 참가자분께서 모델 개발 과정에서 모델의 성능을 확인하기 위한 점수로, KLAID의 리더보드에 등록되는 점수와는 차이가 있을 수 있습니다. 참가자분께서 Evaluation Script로 얻은 결과 번들의 UUID를 klaid@lawcompany.co.kr 보내주시면 담당자가 확인 후 Test Data로 평가하여 리더보드에 추가합니다. 추가하는 과정은 최대 2주까지 소요될 수 있습니다.
            </p>
            <pre><code>※ 모델의 이름도 같이 보내주세요.
※※ Challenge에 참가하시는 분은 <a href="/register">참가등록</a>을 해주세요.
            </code></pre>
            
            <img src="assets/images/leaderboard-submission/Untitled 13-1.png" alt="1"
                    class="img-thumbnail mx-auto d-block">
        </CardBody></Card>
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          <Card><CardBody>
          <div class="mb-4 h1 card-title"><h2>문의처</h2></div>
            <p class="card-text">
              추가로 문의하실 사항이 있다면 klaid@lawcompany.co.kr 로 문의주시기 바랍니다 🙂
            </p>
        </CardBody></Card>
        </Col>
      </Row>
    </Container>
  </div>
  